module.exports = __webpack_public_path__ + "static/media/Room-1.f4c696be.jpg";